import common from '../../common';

const _draw = Symbol('_draw');
const _drawColour = Symbol('_drawColour');
const _stopAudio = Symbol('_stopAudio');
const _onColour_Changed = Symbol('_onColour_Changed');

export default class Spray{
	constructor() {
		// Constants.
		this.DENSITY = 40;
		this.PERIOD = 0.05;
		this.RADIUS = 15;

		// Attributes.
		this._drawLayer = null;
		this._drawPosition = null;
		this._colour = null;
		this._audio = null;
		this._drawTween = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;
		this._colour = common.gameConfig.palettePanel.pages[0][0];

		// Signals.
		common.game.scene.palettePanel.signals.onColourChanged.add(this[_onColour_Changed], this);
	}

	onDrawBegan(point) {
		this._drawPosition = new PIXI.Point(point.x, point.y);
		this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
		this[_draw]();

		// Sfx.
		this._audio = P3.audio.playSound('sfx_tool_spraycan_use_loop_00', {'loop': true});
	}

	onDrawMoved(from, to) {
		this._drawPosition.x = to.x;
		this._drawPosition.y = to.y;
	}

	onDrawEnded() {
		this._drawTween && this._drawTween.stop();

		this._drawPosition = null;
		// Sfx.
		this[_stopAudio]();
	}

	[_draw](){
		if (this._drawPosition == null)
			return;

		for (let i = this.DENSITY; i--;) {
			this._drawLayer.context.save();

			this[_drawColour]();

			this._drawLayer.context.restore();
		}

		this._drawTween = new P3.utils.TWEEN.Tween(this)
			.to({}, this.PERIOD)
			.easing(P3.utils.Easing.Back2.Out)
			.onComplete(()=>{
				this[_draw]();
			})
			.start();

		this._drawLayer.onContext_Changed();
	}

	[_drawColour](){
		const angle = P3.math.random(0, Math.PI * 2);
		const radius = P3.math.random(0, this.RADIUS);

		this._drawLayer.context.fillStyle = this._colour;
		this._drawLayer.context.globalAlpha = Math.random();
		this._drawLayer.context.fillRect(
			this._drawPosition.x + radius * Math.cos(angle),
			this._drawPosition.y + radius * Math.sin(angle),
			P3.math.random(1, 2), P3.math.random(1, 2));
	}

	[_stopAudio](){
		this._audio && this._audio.stop();
		this._audio = null;
	}

	[_onColour_Changed](selection) {
		if (selection.indexOf('#') === 0)
			this._colour = selection;
	}

	get paletteItem(){
		return this._colour;
	}
}